<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="审批编码：" prop="applicantInfo">
            <el-input v-model="query.num" placeholder="请输入审批编号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人信息：" prop="customerInfo">
            <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人身份：">
            <el-input v-model="query.applyLevelName" placeholder="请输入申请人身份" size="small" clearable />
          </el-form-item>
          <el-form-item label="提交来源：">
            <el-select v-model="query.dataSource" placeholder="请选择" clearable size="small">
              <el-option label="app业务员提交" :value="1"></el-option>
              <el-option label="管理后台提交" :value="2"></el-option>
              <el-option label="app客户申请" :value="3"></el-option>
              <el-option label="管理后台导入" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请类型：">
            <el-select v-model="query.registrationType" placeholder="请选择" clearable size="small">
              <el-option label="普通人员升级研修班" :value="1"></el-option>
              <el-option label="普通人员升级体验班" :value="2"></el-option>
              <el-option label="体验班升级研修班" :value="3"></el-option>
              <el-option label="体验班降级为普通人员" :value="10"></el-option>
              <el-option label="研修班降级为普通人员" :value="20"></el-option>
              <el-option label="研修班降级体验班" :value="30"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付单号：">
            <el-input v-model="query.payNum" placeholder="请输入支付单号" size="small" clearable />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="提交时间" :value="0"></el-option>
              <el-option label="初审时间" :value="2"></el-option>
              <el-option label="终审/驳回时间" :value="1"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleTabChange">
          <el-tab-pane label="初审中" name="-1" />
          <el-tab-pane label="终审中" name="0" />
          <el-tab-pane label="同意申请" name="1" />
          <el-tab-pane label="驳回申请" name="2" />
        </el-tabs>
      </div>

      <el-table v-loading="listLoading" :data="list" style="width: 100%">
        <el-table-column label="审批编号" align="center" width="160">
          <template slot-scope="{row}">
            <div @click="handleShowDetail(row.id)">
              <el-link type="primary">{{row.num}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提交人信息" align="center" width="140">
          <template slot-scope="{ row }">
            <div v-if="row.applyName">{{ row.applyName}}
              <div>{{ row.applyLevelName }}{{ row.applyPho ? '(' + row.applyPho + ')' : '' }}</div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="提交来源" align="center" width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.dataSource === 1">app业务员提交</span>
            <span v-if="row.dataSource === 2">管理后台提交</span>
            <span v-if="row.dataSource === 3">app客户申请</span>
            <span v-if="row.dataSource === 4">管理后台导入</span>
          </template>
        </el-table-column>
        <el-table-column label="申请类型" align="center" width="140" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ getApplyType(row) }}
          </template>
        </el-table-column>
        <el-table-column label="用户信息" align="center" width="140">
          <template slot-scope="{ row }">
            <div>{{ row.customerName }} <span v-if="row.currentLevelName">({{ row.currentLevelName }})</span></div>
            <div>{{ row.customerPho }}</div>
          </template>
        </el-table-column>

        <el-table-column label="报名费用" align="center" width="140" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{ row.registrationType<10 && row.payPOList && row.payPOList.length ? (row.fee || '') : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="赠送金额" prop="upgradeGiftAmount" align="center"/>
        <el-table-column label="付款凭证" prop="deptName" align="center" width="200">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.registrationType<10 && row.payPOList && row.payPOList.length">
              <el-image style="width: 50px; height: 50px;margin-right:5px" :src="item.payImg"
                :preview-src-list="[item.payImg]" v-for="item in row.payPOList" :key="item.id"></el-image>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="支付单号" prop="" align="center">
          <template slot-scope="{row}">
            <span v-if="row.registrationType<10 && row.payPOList && row.payPOList.length">
              {{row.payPOList.map(i => (i.payNum)).filter(i => i).join(',')}}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="附件" prop="" align="center" width="200">
          <template slot-scope="{row}">
            <span class="imgs" v-if="row.registrationType<10 && row.applyVoucher">
              <el-image style="width: 50px; height: 50px;margin-right:5px" :src="item" :preview-src-list="[item]"
                v-for="(item, index) in row.applyVoucher.split(',')" :key="index"></el-image>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="申请原因" prop="content" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="赠送礼包" align="center" prop="giftCombineName" width="120"></el-table-column>
        <el-table-column label="提交时间" align="center" width="180">
          <template slot-scope="{ row }">
            {{ getApplyTime(row) }}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName != '-1'" label="初审时间" align="center" width="180">
          <template slot-scope="{ row }">
            {{ getAuditTime(row) }}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName != '-1'" label="初审人" align="center" width="120">
          <template slot-scope="{ row }">
            {{row.auditRealNamePre}}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName === '1'" label="终审时间" align="center" width="120">
          <template slot-scope="{ row }">
            {{row.auditTime}}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName === '1'" label="终审人" align="center" width="120">
          <template slot-scope="{ row }">
            {{row.auditRealName}}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName === '2'" label="驳回原因" align="center" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ getRejectReason(row) }}
          </template>
        </el-table-column>
        <el-table-column v-if="['-1', '0'].includes(activeName)" label="操作" align="center" fixed="right" width="160">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openApproveDialog(row)" v-if="activeName==='-1'" v-hasPermi="['customer:identity:first']">同意</el-button>
            <el-button type="text" @click="openRejectDialog(row)" v-if="activeName==='-1'" v-hasPermi="['customer:identity:first']">驳回</el-button>
            <el-button type="text" @click="openApproveDialog(row)" v-if="activeName==='0'" v-hasPermi="['customer:identity:last']">同意</el-button>
            <el-button type="text" @click="openRejectDialog(row)" v-if="activeName==='0'" v-hasPermi="['customer:identity:last']">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>

    <!-- 同意审核弹窗 -->
    <approve-dialog ref="approveDialog" @approve="handleApproveConfirm" @refresh="doQueryList({})" />
    <!-- 驳回审核弹窗 -->
    <reject-dialog ref="rejectDialog" @reject="handleRejectConfirm" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import ApproveDialog from './approveDialog.vue'
import RejectDialog from './rejectDialog.vue'
export default {
  components: {
    Pagination,
    ApproveDialog,
    RejectDialog
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      query: {
        pageNo: 1,
        pageSize: 20,
        num: undefined,
        nameOrPho: undefined,
        nameOrPho: undefined,
        applyLevelName: undefined,
        currentLevelName: undefined,
        registrationType: undefined,
        dataSource: undefined,
        timeType: 0,
        createdTimeStart: undefined,
        createdTimeEnd: undefined,
        auditTimeStart: undefined,
        auditTimeEnd: undefined,
        payTimeStart: undefined,
        payTimeEnd: undefined
      },
      dateTime: null,
      activeName: '-1',
      // 审核弹窗
      dialogLoading: false,
      currentRow: null,
      sectionList: [],
      dataSourceArr: ['', 'app业务员提交', '管理后台提交', 'app客户申请', '管理后台导入']
    }
  },
  created() {
    // 从意向金管理「加盟申请」跳转过来时带手机号，直接按它查
    if (this.$route.query.nameOrPho) this.query.nameOrPho = String(this.$route.query.nameOrPho)
    this.doQueryList({ pageNo: 1 })
    this.sectionList = JSON.parse(localStorage.getItem('levelList'))
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 20,
        num: undefined,
        nameOrPho: undefined,
        nameOrPho: undefined,
        applyLevelName: undefined,
        currentLevelName: undefined,
        registrationType: undefined,
        dataSource: undefined,
        timeType: 0,
        createdTimeStart: undefined,
        createdTimeEnd: undefined,
        auditTimeStart: undefined,
        auditTimeEnd: undefined,
        payTimeStart: undefined,
        payTimeEnd: undefined
      }
      this.dateTime = null
      this.doQueryList({ pageNo: 1 })
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    handleTabChange() {
      this.doQueryList({ pageNo: 1 })
    },
    async doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize

      const query = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        state: Number(this.activeName || 0)
      }

      // 编码
      if (this.query.num) {
        query.num = this.query.num.trim()
      }
      // 申请人信息（提交资料人姓名/电话）
      if (this.query.nameOrPho) {
        query.nameOrPho = this.query.nameOrPho.trim()
      }
      // 客户信息（姓名/电话）
      if (this.query.nameOrPho) {
        query.nameOrPho = this.query.nameOrPho.trim()
      }
      // 申请人身份
      if (this.query.applyLevelName) {
        query.applyLevelName = this.query.applyLevelName.trim()
      }
      // 级别名称
      if (this.query.currentLevelName) {
        query.currentLevelName = this.query.currentLevelName.trim()
      }
      // 申请类型
      if (this.query.registrationType) {
        query.registrationType = this.query.registrationType
      }
      // 数据来源
      if (this.query.dataSource) {
        query.dataSource = this.query.dataSource
      }
      // 时间范围处理
      if (this.dateTime && this.dateTime.length === 2) {
        const timeType = this.query.timeType
        if (timeType === 0) {
          // 提交时间
          query.createdTimeStart = this.dateTime[0]
          query.createdTimeEnd = this.dateTime[1]
        } else if (timeType === 1) {
          // 通过/驳回时间
          query.auditTimeStart = this.dateTime[0]
          query.auditTimeEnd = this.dateTime[1]
        } else if (timeType === 2) {
          // 付款时间
          query.payTimeStart = this.dateTime[0]
          query.payTimeEnd = this.dateTime[1]
        }
      }

      this.listLoading = true
      try {
        const { data } = await customerRegistrationApi.fetchList(query)
        this.list = (data && (data.list || data.records)) || []
        this.total = (data && data.total) || 0
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.listLoading = false
      }
    },
    getApplyLevelName(row) {
      // 升级后的身份名称
      if (!row) return '-'
      return row.levelName || row.toLevelName || row.newLevelName || '-'
    },
    //申请类型
    getApplyType(row) {
      if (!row) return '-'
      if (row.registrationType === 1) return '普通人员升级研修班'
      if (row.registrationType === 2) return '普通人员升级体验班'
      if (row.registrationType === 3) return '体验班升级研修班'
      if (row.registrationType === 10) return '体验班降级为普通人员'
      if (row.registrationType === 20) return '研修班降级为普通人员'
      if (row.registrationType === 30) return '研修班降级为体验班'
      return '-'
    },
    getApplyStatusText(row) {
      if (!row) return '-'
      const state = row.state
      if (state === 0) return '待审核'
      if (state === 1) return '审核通过'
      if (state === 2) return '审核失败'
      return '待审核'
    },
    getApplyTime(row) {
      return (row && (row.createdTime || row.applyTime)) || ''
    },
    getAuditTime(row) {
      return (row && row.auditTimePre) || ''
    },
    getAuditUser(row) {
      return (row && (row.auditUserName || row.realName || row.auditUser)) || ''
    },
    getRejectReason(row) {
      return (row && (row.reasonForRejection || row.statereason || row.reason || row.remarks)) || '-'
    },
    getRegistrationId(row) {
      return row && (row.id || row.registrationId)
    },
    openApproveDialog(row) {
      this.currentRow = row
      if (this.getRegistrationId(row) == null) {
        this.$message.error('当前数据缺少报名信息，无法审核')
        return
      }
      this.approveForm = {
        bankNum: ''
      }
      this.$refs.approveDialog.handleCreate(row)
    },
    openRejectDialog(row) {
      this.currentRow = row
      if (this.getRegistrationId(row) == null) {
        this.$message.error('当前数据缺少报名信息，无法审核')
        return
      }
      this.rejectForm = {
        remarks: ''
      }
      this.$refs.rejectDialog.handleCreate(row)
    },
    handleApproveConfirm(params, callback) {
      this.dialogLoading = true
      const auditParams = {
        id: params.id,
        isPass: params.isPass,
        bankNum: params.bankNum || '',
        upgradeGiftAmount: params.upgradeGiftAmount || 0
      }
      customerRegistrationApi
        .auditPre(auditParams)
        .then(() => {
          this.$message.success('审核通过')
          this.doQueryList({})
        })
        .catch(err => {
          this.$message.error((err && (err.msg || err.message)) || '审核失败')
        })
        .finally(() => {
          this.dialogLoading = false
          if (callback) callback()
        })
    },
    handleRejectConfirm(params, callback) {
      this.dialogLoading = true
      const rejectParams = {
        id: params.id,
        state: 2,
        reasonForRejection: params.reasonForRejection,
        bankNum: '',
        upgradeGiftAmount: 0
      }
      const auditPreParams = {
        bankNum: '',
        id: params.id,
        isPass: false,
        remarks: params.reasonForRejection,
        upgradeGiftAmount: 0
      }
      
      const apiCall = this.activeName === '-1' 
        ? customerRegistrationApi.auditPre(auditPreParams)
        : customerRegistrationApi.agreeOrReject(rejectParams)
      
      apiCall.then(() => {
        this.$message.success('已驳回申请')
        this.doQueryList({})
        if (callback) callback()
      })
        .catch(err => {
          this.$message.error((err && (err.msg || err.message)) || '操作失败')
          if (callback) callback()
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },
    //查看信息
    handleShowDetail(id) {
     
      this.$router.push({
        path: '/finance/proofAudit',
        query: { id: id, from: 'customerIdentityChangeAudit' }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 10px 0;
}

.dialog-warning {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 14px;
  color: #333;
}

.dialog-icon {
  color: #e6a23c;
  font-size: 20px;
  margin-right: 8px;
}

.placeholder-text {
  color: #999;
  font-size: 13px;
}
</style>
